import { render, staticRenderFns } from "./NewsFeedSection.vue?vue&type=template&id=ee7c8746&scoped=true&"
import script from "./NewsFeedSection.vue?vue&type=script&lang=js&"
export * from "./NewsFeedSection.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedSection.vue?vue&type=style&index=0&id=ee7c8746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7c8746",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee7c8746')) {
      api.createRecord('ee7c8746', component.options)
    } else {
      api.reload('ee7c8746', component.options)
    }
    module.hot.accept("./NewsFeedSection.vue?vue&type=template&id=ee7c8746&scoped=true&", function () {
      api.rerender('ee7c8746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontPage/NewsFeedSection.vue"
export default component.exports